module.exports = __webpack_public_path__ + "media/images/landing/illust/mockup-85e329b65bff2c1a6c47befad3705079.png";